import React from "react";

import { formatCurrency } from "./dashboardUtils";

export default function DashboardSummaryCards({
  inventoryData,
  isLoadingInventory,
  purchaseData,
  isLoadingPurchase,
  thresholdData,
  isLoadingThreshold,
}) {
  const fontStyle = { fontFamily: "'Inter', sans-serif" };

  return (
    <div
      className="!font-inter !grid !grid-cols-1 md:!grid-cols-3 !gap-4"
      style={fontStyle}
    >
      {/* 1. Tồn kho - Blue Accent */}
      <div
        className="!bg-gradient-to-br !from-white !to-blue-50/30 !rounded-2xl !p-5 !shadow-xs !border !border-blue-100/80 !flex !flex-col !justify-between !space-y-3.5 hover:!border-blue-200 !transition-all"
        style={fontStyle}
      >
        <div className="!space-y-2" style={fontStyle}>
          <div
            className="!flex !items-center !justify-between"
            style={fontStyle}
          >
            <span
              className="!text-sm !font-bold !text-blue-800/90 !uppercase !tracking-wider"
              style={fontStyle}
            >
              Tổng Tiền Tồn Kho
            </span>
            <div className="!w-8 !h-8 !rounded-xl !bg-blue-50 !border !border-blue-200/80 !text-blue-700 !flex !items-center !justify-center !shrink-0">
              <svg
                className="!w-4 !h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2.2"
                  d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                />
              </svg>
            </div>
          </div>

          <div
            className="!text-2xl sm:!text-3xl !font-black !text-blue-900"
            style={fontStyle}
          >
            {isLoadingInventory ? (
              <span className="!text-slate-400 !animate-pulse">
                Đang tải...
              </span>
            ) : (
              formatCurrency(inventoryData?.total_amount)
            )}
          </div>
        </div>

        <div
          className="!pt-3 !border-t !border-blue-100/70 !flex !items-center !justify-between !text-sm !text-slate-600"
          style={fontStyle}
        >
          <span style={fontStyle}>
            Từ ngày:{" "}
            <strong className="!text-slate-800">
              {inventoryData?.from_date || "-"}
            </strong>
          </span>
          <span style={fontStyle}>
            Đến ngày:{" "}
            <strong className="!text-slate-800">
              {inventoryData?.to_date || "-"}
            </strong>
          </span>
        </div>
      </div>

      {/* 2. Mua hàng - Emerald Accent */}
      <div
        className="!bg-gradient-to-br !from-white !to-emerald-50/30 !rounded-2xl !p-5 !shadow-xs !border !border-emerald-100/80 !flex !flex-col !justify-between !space-y-3.5 hover:!border-emerald-200 !transition-all"
        style={fontStyle}
      >
        <div className="!space-y-2" style={fontStyle}>
          <div
            className="!flex !items-center !justify-between"
            style={fontStyle}
          >
            <span
              className="!text-sm !font-bold !text-emerald-800/90 !uppercase !tracking-wider"
              style={fontStyle}
            >
              Tổng Tiền Mua Hàng
            </span>
            <div className="!w-8 !h-8 !rounded-xl !bg-emerald-50 !border !border-emerald-200/80 !text-emerald-700 !flex !items-center !justify-center !shrink-0">
              <svg
                className="!w-4 !h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2.2"
                  d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                />
              </svg>
            </div>
          </div>

          <div
            className="!text-2xl sm:!text-3xl !font-black !text-emerald-900"
            style={fontStyle}
          >
            {isLoadingPurchase ? (
              <span className="!text-slate-400 !animate-pulse">
                Đang tải...
              </span>
            ) : (
              formatCurrency(purchaseData?.total_amount)
            )}
          </div>
        </div>

        <div
          className="!pt-3 !border-t !border-emerald-100/70 !flex !items-center !justify-between !text-sm !text-slate-600"
          style={fontStyle}
        >
          <span style={fontStyle}>
            Từ ngày:{" "}
            <strong className="!text-slate-800">
              {purchaseData?.from_date || "-"}
            </strong>
          </span>
          <span style={fontStyle}>
            Đến ngày:{" "}
            <strong className="!text-slate-800">
              {purchaseData?.to_date || "-"}
            </strong>
          </span>
        </div>
      </div>

      {/* 3. Định mức tồn kho - Indigo Accent */}
      <div
        className="!bg-gradient-to-br !from-white !to-indigo-50/30 !rounded-2xl !p-5 !shadow-xs !border !border-indigo-100/80 !flex !flex-col !justify-between !space-y-3.5 hover:!border-indigo-200 !transition-all"
        style={fontStyle}
      >
        <div className="!space-y-2" style={fontStyle}>
          <div
            className="!flex !items-center !justify-between"
            style={fontStyle}
          >
            <span
              className="!text-sm !font-bold !text-indigo-800/90 !uppercase !tracking-wider"
              style={fontStyle}
            >
              Định Mức Ngày Thường
            </span>
            <div className="!w-8 !h-8 !rounded-xl !bg-indigo-50 !border !border-indigo-200/80 !text-indigo-700 !flex !items-center !justify-center !shrink-0">
              <svg
                className="!w-4 !h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2.2"
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
            </div>
          </div>

          <div
            className="!text-2xl sm:!text-3xl !font-black !text-indigo-900"
            style={fontStyle}
          >
            {isLoadingThreshold ? (
              <span className="!text-slate-400 !animate-pulse">
                Đang tải...
              </span>
            ) : (
              formatCurrency(thresholdData?.weekday_normal_amount)
            )}
          </div>
        </div>

        <div
          className="!pt-3 !border-t !border-indigo-100/70 !grid !grid-cols-2 !gap-2 !text-sm !text-slate-600"
          style={fontStyle}
        >
          <div style={fontStyle}>
            Cuối tuần:{" "}
            <strong className="!text-slate-800">
              {formatCurrency(thresholdData?.weekend_normal_amount)}
            </strong>
          </div>
          <div style={fontStyle}>
            Lễ ngày thường:{" "}
            <strong className="!text-slate-800">
              {formatCurrency(thresholdData?.weekday_holiday_amount)}
            </strong>
          </div>
          <div className="!col-span-2" style={fontStyle}>
            Lễ cuối tuần:{" "}
            <strong className="!text-slate-800">
              {formatCurrency(thresholdData?.weekend_holiday_amount)}
            </strong>
          </div>
        </div>
      </div>
    </div>
  );
}
